import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CONFIG, Config } from '../environment/config';
import {
  CfbEnvironmentFeatureFlags,
  CfbFeatureFlagKey,
} from './cfb-feature-flag.model';
import {
  getCfbFeatureFlagsForEnvironment,
  isCfbFeatureFlagEnabled,
} from './cfb-feature-flag.util';

@Injectable({
  providedIn: 'root',
})
export class CfbFeatureFlagService {
  constructor(
    private translate: TranslateService,
    @Inject(CONFIG) private config: Config,
  ) {}

  getEnvironmentName(): string {
    return this.config.api.identity.environmentName;
  }

  getFlagsForCurrentEnvironment(): CfbEnvironmentFeatureFlags {
    return getCfbFeatureFlagsForEnvironment(
      this.translate,
      this.getEnvironmentName(),
    );
  }

  isEnabled(flagKey: CfbFeatureFlagKey): boolean {
    return isCfbFeatureFlagEnabled(
      this.translate,
      this.getEnvironmentName(),
      flagKey,
    );
  }

  isIntegrationOn(): boolean {
    return this.isEnabled('isIntegrationOn');
  }
}
